/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Faq_1_QuestionInputs */

const en_svc_agents_faq_1_question = /** @type {(inputs: Svc_Agents_Faq_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the difference between an AI agent and a chatbot?`)
};

const lv_svc_agents_faq_1_question = /** @type {(inputs: Svc_Agents_Faq_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ar ko AI aģents atšķiras no čatbota?`)
};

/**
* | output |
* | --- |
* | "What is the difference between an AI agent and a chatbot?" |
*
* @param {Svc_Agents_Faq_1_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_faq_1_question = /** @type {((inputs?: Svc_Agents_Faq_1_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Faq_1_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_faq_1_question(inputs)
	return en_svc_agents_faq_1_question(inputs)
});